import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import SteamConnect from 'Components/Account/LinkedAccounts/SteamConnect';
import EpicConnect from 'Components/Account/LinkedAccounts/EpicConnect';
import { refreshAuth } from 'Redux/ducks/auth';
import store from 'Redux/store';

import 'Components/Account/LinkedAccounts/LinkedAccounts.scss';

export default function LinkedAccounts() {
  useEffect(() => {
    store.dispatch(refreshAuth());
  }, []);

  return (
    <section className="account-content">
      <h1>
        <FormattedMessage id="account-linked-accounts.heading" defaultMessage="Linked Accounts" />
      </h1>
      <article className="account-table">
        <h2 className="account-table-heading">
          <FormattedMessage id="account-linked-accounts.steam" defaultMessage="Steam" />
        </h2>
        <div className="account-table-row">
          <div className="linked-accounts">
            <SteamConnect />
          </div>
        </div>
      </article>

      <article className="account-table">
        <h2 className="account-table-heading">
          <FormattedMessage id="account-linked-accounts.title" defaultMessage="Epic" />
        </h2>
        <div className="account-table-row">
          <div className="linked-accounts">
            <EpicConnect />
          </div>
        </div>
      </article>
    </section>
  );
}
